import React from "react";
import Button from "../Button/Button";

import "./style.css";

export default function Review({ item, isAdmin, approveReview, deleteReview }) {
  return (
    <div className="review-wrapper">
      <div className="rating">
        <ul>
          {[...Array(5)].map((star, i) => {
            if (i + 1 <= item.stars) {
              return (
                <li key={"star" + i}>
                  <i className="fi flaticon-star"></i>
                </li>
              );
            } else {
              return (
                <li key={"star" + i}>
                  <i className="fi flaticon-star-1"></i>
                </li>
              );
            }
          })}
        </ul>
      </div>
      <div className="quote">
        <p>{item.text}</p>
      </div>
      <div className="client-info">
        <div className="client-text">
          <h5>{item.senderName}</h5>
          {isAdmin && <p>{item.email}</p>}
        </div>
      </div>
      {isAdmin && (
        <div className="review-admin-buttons">
          {item.status === "pending" && (
            <Button text="Одобри" onClick={() => approveReview(item)} />
          )}
          <Button
            text="Изтрий"
            classes={["delete-button"]}
            onClick={deleteReview}
          />
        </div>
      )}
    </div>
  );
}
